export const BI_ERRORS = {
  getWindow: {
    // last 7023
    album: {
      load: {
        id: '7004',
        name: 'getWindow.album.load',
      },
      notReady: {
        id: '7020',
        name: 'getWindow.notReady',
      },
    },
    cover: {
      load: {
        id: '7006',
        name: 'getWindow.cover.load',
      },
    },
    siteSettings: {
      obtain: {
        id: '7005',
        name: 'getWindow.siteSettings.obtain',
      },
    },
    siteInfo: {
      id: '7018',
      name: 'getWindow.siteInfo',
    },
    dgs: {
      freeDownloadLinks: {
        id: '7019',
        name: 'getWindow.dgs.freeDownloadLinks',
      },
      downloadLinksByOrder: {
        id: '7008',
        name: 'getWindow.dgs.downloadLinksByOrder',
      },
      createSnapshotId: {
        id: '7013',
        name: 'getWindow.dgs.createSnapshotId',
      },
      downloadLinksBySnapshot: {
        id: '7014',
        name: 'getWindow.dgs.downloadLinksBySnapshot',
      },
      saveUserEmail: {
        id: '7015',
        name: 'getWindow.dgs.saveUserEmail',
      },
      subscribeDownload: {
        id: '7016',
        name: 'getWindow.dgs.subscribeDownload',
      },
      canPayWithDgs: {
        id: '7017',
        name: 'getWindow.dgs.canPayWithDgs',
      },
      checkZipStatus: {
        id: '7021',
        name: 'getWindow.dgs.checkZipStatus',
      },
    },
    freeDownloadLinks: {
      id: '7001',
      name: 'getWindow.freeDownloadLinks',
    },
    zeroNameYourPriceDownloadLinks: {
      id: '7007',
      name: 'getWindow.zeroNameYourPriceDownloadLinks',
    },
    subscribeToDownload: {
      id: '7002',
      name: 'getWindow.subscribeToDownload',
    },
    cashier: {
      unknownStatus: {
        id: '7010',
        name: 'getWindow.cashier.unknownStatus',
      },
      genericError: {
        id: '7011',
        name: 'getWindow.cashier.genericError',
      },
      merchantSettingsFetch: {
        id: '7012',
        name: 'getWindow.cashier.merchantSettingsFetch',
      },
      storeMandatoryFields: {
        id: '7021',
        name: 'getWindow.cashier.storeMandatoryFields',
      },
    },
    unhandled: {
      rejection: {
        id: '7003',
        name: 'getWindow.unhandled.rejection',
      },
      generic: {id: '7022', name: 'getWindow.unhandled.generic'},
      boundary: {id: '7023', name: 'getWindow.unhandled.boundary'},
    },
  },
};
